import { render, staticRenderFns } from "./bill-form.vue?vue&type=template&id=1158a86b&scoped=true"
import script from "./bill-form.vue?vue&type=script&lang=js"
export * from "./bill-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1158a86b",
  null
  
)

export default component.exports